import Config from 'conf';

export default socketMiddleware => {
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        updateConsoProd: function(fheCenter_mac, type, product_modules) {
            return new Promise((resolve, reject) => {
                let configureConsoProdFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac && type === args.type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('configureConsoProdFeedback', configureConsoProdFeedback);
                        if (args.res === 'success') return resolve(args);
                        return reject(new Error(args.error_msg));
                    }
                };
                socketOn('configureConsoProdFeedback', configureConsoProdFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('configureConsoProdFeedback', configureConsoProdFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('configureConsoProd', { fheCenter_mac, type, product_modules });
            });
        },
        configureTendaRouter: function(fheCenter_mac, boxId) {
            return new Promise((resolve, reject) => {
                let configureTendaRouterFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('configureTendaRouter', configureTendaRouterFeedback);
                        if (args.res === 'success') return resolve(args.SSID);
                        return reject(args.error);
                    }
                };
                socketOn('configureTendaRouter',configureTendaRouterFeedback );

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('configureTendaRouter', configureTendaRouterFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('configureTendaRouter', { fheCenter_mac, boxId});
            })
        }
    };
};



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/Home/index.js